<template>
  <v-form ref="form" v-model="valid" lazy-validation @close="close" @submit="submit">
    <v-card class="border">
      <v-card-title style="display: contents">
        <v-card class="card-header" style="box-shadow: none;">
          <span :class="{ 'text-h5' : !isDisplaySmall }">{{ cardTitleName }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                height="18"
                @click="close"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
      </v-card-title>

      <v-card class="card-icon" v-if="!isDisplaySmall">
        <v-icon class="icon-header-card">mdi-cog-outline</v-icon>
      </v-card>

      <v-card-text class="pb-0">
        <v-row class="row-info-intercom">
          <v-card outlined class="border card-info mt-2 mb-2">
            <div class="pa-4 grid-container">
              <div>
                <p>id</p>
                <p>ip-адрес</p>
                <p>Серийный номер</p>
                <p v-if="device.mac_address">MAC-адрес</p>
                <p>Производитель устройства</p>
                <p>Модель</p>
                <p>Технический комментарий</p>
                <p v-if="device.type">Тип</p>
                <p v-if="device.model_id === 7 && device.barrier && device.barrier.passage_type === 'G'">ГРЗ:</p>
                <p v-if="device.model_id === 7 && device.barrier && device.barrier.passage_type === 'B'">ГРЗ:</p>
                <p v-if="device.model_id === 7 && device.barrier && device.barrier.passage_type === null">ГРЗ:</p>
                <p v-if="device.firmware_version">Версия ПО:</p>
                <p v-if="adminCodes.scanByCode">Код сканирования RFID:</p>
                <p>Код открытия</p>
                <p v-if="displayCode && adminCodes.doors[0].code">Код открытия №1:</p>
                <p v-if="displayCode && adminCodes.doors[1].code">Код открытия №2:</p>
                <p v-if="control">Пароль администратора:</p>
              </div>
              <div style="border-left: 1px solid #707079;">
                <p class="intercom-info">{{ device.id }}</p>
                <p class="intercom-info">{{ device.ip_address }}</p>
                <p class="intercom-info">{{ device.serial_number}}</p>
                <p class="intercom-info" v-if="device.mac_address">
                  {{ device.mac_address }}
                  <v-btn
                  icon
                  @click="copyToClipboard(device.mac_address)"
                  style="height: auto;"
                  >
                    <v-icon small>
                      mdi-content-copy
                    </v-icon>
                  </v-btn>
                </p>
                <p class="intercom-info">{{ device.manufacturer }}</p>
                <p class="intercom-info" v-if="device.model">{{ device.model }}</p>
                <p class="intercom-info intercom-info--technical-comment">
                  <expandable-text
                    :text="device.technical_comment"
                    :max-length="50"
                    :single-line-collapsed="true"
                  />
                </p>
                <p class="intercom-info" v-if="device.type">{{ getDisplayType }}</p>
                <p class="intercom-info" v-if="device.model_id === 7 && device.barrier && device.barrier.passage_type === 'G'">
                  <router-link class="routerLink" :to="`/barrier/${device.barrier.id}`">
                    Ворота
                  </router-link>
                </p>
                <p class="intercom-info" v-if="device.model_id === 7 && device.barrier && device.barrier.passage_type === 'G'">
                  <router-link class="routerLink" :to="`/barrier/${device.barrier.id}`">
                    Шлагбаум
                  </router-link>
                </p>
                <p class="intercom-info" v-if="device.model_id === 7 && device.barrier && device.barrier.passage_type === null">
                  Не привязан
                </p>
                <p class="intercom-info" v-if="device.firmware_version">{{ device.firmware_version }}</p>
                <p class="intercom-info" v-if="adminCodes.scanByCode">{{ adminCodes.scanByCode }}</p>
                <p class="intercom-info">{{ adminCodes.serviceDoorCode }}</p>
                <p class="intercom-info" v-if="displayCode && adminCodes.doors[0].code">{{ adminCodes.doors[0].code }}</p>
                <p class="intercom-info" v-if="displayCode && adminCodes.doors[1].code">{{ adminCodes.doors[1].code }}</p>
                <p class="intercom-info" v-if="control">
                  <span v-if="loadingAdminPassword" style="display: inline-flex; align-items: center;">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      size="16"
                      width="2"
                      style="margin-right: 8px;"
                    ></v-progress-circular>
                    Загрузка...
                  </span>
                  <span v-else-if="adminPasswordError" style="display: inline-flex; align-items: center; gap: 8px;">
                    <span style="color: #d32f2f;">Не удалось получить данные</span>
                    <v-btn
                      icon
                      x-small
                      @click="retryLoadAdminPassword"
                      :disabled="retryAttempts >= 2 || loadingAdminPassword"
                      color="primary"
                      style="height: auto;"
                      :title="retryAttempts >= 2 ? 'Превышено количество попыток' : 'Повторить попытку'"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </span>
                  <span v-else>{{ adminPassword || 'Не загружен' }}</span>
                  <v-btn
                    icon
                    small
                    v-if="$checkPermission('update_main_setups')"
                    @click="openEditAdminPasswordDialog"
                    :disabled="loadingAdminPassword || !!adminPasswordError"
                    style="height: auto; margin-left: 5px;"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </p>
              </div>
            </div>
          </v-card>
        </v-row>

        <div style="display: block; text-align: center;" class="mt-8 pb-5">
          <v-btn
            v-if="disableRoleName"
            class="btn btn-web-device border mr-2"
            large
            style="color: white;"
            outlined
            prepe
            :href="transitionWebDevice"
            target="_blank"
            rel="noopener noreferrer"
          >
            Веб-интерфейс
          </v-btn>
          <v-btn
            v-if="$checkPermission('update_device')"
            class="btn btn-code border"
            large
            outlined
            prepe
            @click.prevent="editDevice(device.id)"
          >
            Редактировать
          </v-btn>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="editAdminPasswordDialog" max-width="600" content-class="dialog-border-radius" persistent>
      <v-card class="admin-password-dialog">
        <v-card-title class="admin-password-dialog__header">
          <div class="admin-password-dialog__header-content">
            <v-icon class="admin-password-dialog__icon" color="white">mdi-lock-reset</v-icon>
            <span class="text-h5 admin-password-dialog__title">Редактирование пароля администратора</span>
          </div>
          <v-btn
            icon
            @click="editAdminPasswordDialog = false"
            class="admin-password-dialog__close-btn"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="admin-password-dialog__content">
          <div class="admin-password-dialog__info">
            <v-icon color="primary" class="admin-password-dialog__info-icon">mdi-information-outline</v-icon>
            <span class="admin-password-dialog__info-text">
              Введите новый пароль администратора для устройства Rubetek
            </span>
          </div>
          <v-text-field
            v-model="adminPasswordInput"
            label="Пароль администратора"
            outlined
            dense
            class="admin-password-dialog__input"
            :rules="[v => !!v || 'Пароль не может быть пустым']"
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="admin-password-dialog__actions">
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="editAdminPasswordDialog = false"
            class="admin-password-dialog__cancel-btn"
          >
            Отмена
          </v-btn>
          <v-btn
            color="primary"
            @click="saveAdminPassword"
            :loading="savingPassword"
            class="admin-password-dialog__save-btn"
            depressed
          >
            <v-icon left>mdi-content-save</v-icon>
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import ExpandableText from '@/components/ExpandableText';

export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
    adminCodes: {
      type: Object,
      default: () => ({}),
    },
    doorphoneId: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
  components: { ExpandableText },
  data: () => ({
    valid: true,
    disableRoleName: false,
    isDisplaySmall: false,
    lastCopiedText: '',
    adminPassword: '',
    editAdminPasswordDialog: false,
    adminPasswordInput: '',
    showPassword: false,
    savingPassword: false,
    loadingAdminPassword: false,
    adminPasswordError: null,
    retryAttempts: 0,
  }),
  mounted () {
    switch (this.roleName) {
      case 'admin': case 'admin-engineer' : this.disableRoleName = true;
        break;
    }
  },
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
    if (this.control && this.doorphoneId) {
      this.loadAdminPassword();
    }
  },
  watch: {
    doorphoneId: {
      handler (newVal) {
        if (this.control && newVal) {
          this.retryAttempts = 0;
          this.loadAdminPassword();
        }
      },
      immediate: false,
    },
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
    control () {
      return this.device.manufacturer === 'Rubetek';
    },
    displayCode () {
      if (this.control) {
        return this.adminCodes.doors;
      } else {
        return '';
      }
    },
    cardTitleName () {
      switch (this.device.model_id) {
        case 7:
          return 'устройство ГРЗ';
        default:
          return this.cardTitleNameDoorphone;
      }
    },
    cardTitleNameDoorphone () {
      switch (this.device?.doorphone?.type) {
        case 'A':
          return 'устройство домофон (доп. вход)';
        case 'G':
          return 'устройство домофон (калитка)';
        case 'M':
          return 'устройство домофон';
        default:
          return 'устройство';
      }
    },
    getDisplayType () {
      switch (this.device?.type) {
        case 'D':
          return 'Домофон';
        case 'B':
          return 'ГРЗ';
        case 'C':
          return 'Контроллер';
        default:
          return '';
      }
    },
    transitionWebDevice () {
      if (this.device.model === 'RV-3434') {
        return `http://${this.device.ip_address}.intercom.access.simdev.ru:8000/`;
      }
      return `http://${this.device.ip_address}.intercom.access.simdev.ru/`;
    },
  },
  methods: {
    ...mapActions({
      getAdminPassword: 'MainSetups/getAdminPassword',
      updateAdminPassword: 'MainSetups/updateAdminPassword',
    }),
    checkSize () {
      this.isDisplaySmall = window.innerWidth <= 800;
    },
    async copyToClipboard (value) {
      if (this.lastCopiedText === value) {
        return;
      }
      try {
        await navigator.clipboard.writeText(value);
        this.lastCopiedText = value;
        this.$flash_success('MAC-адрес скопирован!');
      } catch (err) {
        this.$flash_danger('Не удалось скопировать MAC-адрес');
      }
    },
    editDevice (id) {
      const routeData = this.$router.resolve({ name: 'EditDevice', params: { id: id } });
      window.open(routeData.href, '_blank');
    },
    async loadAdminPassword () {
      if (!this.control || !this.doorphoneId) {
        return;
      }
      this.loadingAdminPassword = true;
      this.adminPasswordError = null;
      try {
        const response = await this.getAdminPassword(this.doorphoneId);
        this.adminPassword = response.admin_password || '';
        this.adminPasswordError = null;
        this.retryAttempts = 0;
      } catch (err) {
        this.adminPassword = '';
        this.adminPasswordError = true;
      } finally {
        this.loadingAdminPassword = false;
      }
    },
    async retryLoadAdminPassword () {
      if (this.retryAttempts >= 2) {
        return;
      }
      this.retryAttempts++;
      await this.loadAdminPassword();
    },
    openEditAdminPasswordDialog () {
      this.adminPasswordInput = this.adminPassword;
      this.editAdminPasswordDialog = true;
    },
    async saveAdminPassword () {
      if (!this.adminPasswordInput) {
        this.$flash_warning('Пароль не может быть пустым');
        return;
      }
      this.savingPassword = true;
      try {
        await this.updateAdminPassword({
          id: this.doorphoneId,
          adminPassword: this.adminPasswordInput,
        });
        this.adminPassword = this.adminPasswordInput;
        this.adminPasswordError = null;
        this.editAdminPasswordDialog = false;
        this.$flash_success('Пароль администратора успешно обновлен');
      } catch (err) {
        this.$flash_danger('Не удалось сохранить пароль администратора');
      } finally {
        this.savingPassword = false;
      }
    },
    async submit () {
      await this.$emit('submit');
    },
    async close () {
      await this.$emit('close');
      this.$emit('update:active', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-header-card {
  font-size: 45px;
  height: 100%;
  color: white;
}
.card-info {
  background-color: rgba(248, 248, 248, 0.35);
  color: black;
  width: auto;
  box-shadow: none;
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.card-icon {
  border-radius: 16px;
  top: 0;
  left: 0;
  position: absolute;
  width: 11%;
  height: 88px;
  max-height: 88px;
  text-align: center;
  background-color: #E0B389;
}
.card-footer {
  border-radius: 16px;
  text-align: center;
  padding-top: 10px;
  min-height: 100px;
  box-shadow: none;
  background-color: rgba(224, 179, 137, 0.5);
}
.btn-code {
  width: 100%;
  max-width: 250px;
  background-color: #E0B389;
  color: white;
}
.btn-web-device {
  width: 100%;
  max-width: 250px;
  background-color: #85B285;
  color: white;
}
.v-application p {
  margin-bottom: 0;
}
.border {
  border-radius: 16px;
}
.intercom-info {
  padding-left: 15px;
}

.intercom-info--technical-comment {
  margin-bottom: 4px !important;
}
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
.grid-container {
  display: grid;
  grid-template-columns: 40% 60%;
}
.row-info-intercom {
  display: block;
  margin-left: 12%;
  margin-right: 12%;
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
  .row-info-intercom {
    margin-left: 2%;
    margin-right: 2%;
  }
  .grid-container {
    grid-template-columns: 50% 50%;
  }
}

.admin-password-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.admin-password-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.admin-password-dialog__header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-password-dialog__icon {
  font-size: 32px !important;
}

.admin-password-dialog__title {
  color: white;
  font-weight: 600;
}

.admin-password-dialog__close-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.admin-password-dialog__content {
  padding: 24px;
}

.admin-password-dialog__info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background-color: #e3f2fd;
  border-left: 4px solid #2196f3;
  padding: 12px 16px;
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 24px;
}

.admin-password-dialog__info-icon {
  margin-top: 2px;
  flex-shrink: 0;
}

.admin-password-dialog__info-text {
  color: #1976d2;
  font-size: 14px;
  line-height: 1.5;
}

.admin-password-dialog__input {
  margin-top: 8px;
}

.admin-password-dialog__actions {
  padding: 16px 24px;
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
}

.admin-password-dialog__cancel-btn {
  margin-right: 12px;
  color: #757575;
}

.admin-password-dialog__save-btn {
  min-width: 140px;
  color: white;
  font-weight: 500;
}
</style>
